
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/service-management/documents/content-theme",
      function () {
        return require("private-next-pages/service-management/documents/content-theme/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/service-management/documents/content-theme"])
      });
    }
  